// main package functionality

function isNullOrEmpty(input){
	// will return true if input is either null, empty, or undefined
	return (input === undefined || input === null || input === "");
}

// here we export the function to make available to other packages
module.exports = isNullOrEmpty;